import { FilterDefinition } from "hooks/useTable";
import React, { useMemo } from "react";
import Card from "components/card/Card";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import TextInput from "components/filters/TextInput";
import SelectBox from "components/filters/SelectBox";
import Checkbox from "components/filters/Checkbox";
import DateRangeInput from "components/filters/DateRangeInput";
import DateInput from "components/filters/DateInput";

interface FilterProps extends FilterDefinition {
  updateFilter: (filterKey: string, value: any) => void;
}

function Filter({
  filterKey,
  label,
  type,
  options,
  updateFilter,
  defaultValue,
  placeholder,
}: FilterProps) {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const renderFilterItem = useMemo(() => {
    switch (type) {
      case "selectbox":
        return (
          <Flex>
            <Card
              flexDirection="column"
              px="16px"
              overflowX={{ sm: "scroll", lg: "scroll" }}
              borderColor={borderColor}
            >
              <Text fontWeight={"semibold"} color={textColor} mb={2}>
                {label}
              </Text>
              <SelectBox
                filterKey={filterKey}
                options={options}
                updateFilter={updateFilter}
                defaultValue={defaultValue}
                placeholder={placeholder}
              />
            </Card>
          </Flex>
        );

      case "input":
        return (
          <Flex>
            <Card
              flexDirection="column"
              px="16px"
              overflowX={{ sm: "scroll", lg: "scroll" }}
              borderColor={borderColor}
            >
              <Text fontWeight={"semibold"} color={textColor} mb={2}>
                {label}
              </Text>
              <TextInput
                filterKey={filterKey}
                label={label}
                updateFilter={updateFilter}
                defaultValue={defaultValue}
              />
            </Card>
          </Flex>
        );

      case "checkbox":
        return (
          <Flex>
            <Card
              flexDirection="column"
              px="16px"
              overflowX={{ sm: "scroll", lg: "scroll" }}
              borderColor={borderColor}
              alignItems="center"
              justifyContent={"center"}
            >
              <Checkbox
                filterKey={filterKey}
                label={label}
                updateFilter={updateFilter}
                defaultValue={defaultValue}
              />
            </Card>
          </Flex>
        );

      case "date":
        return (
          <Flex>
            <Card
              flexDirection="column"
              px="16px"
              overflowX={{ sm: "scroll", lg: "scroll" }}
              borderColor={borderColor}
            >
              <Text fontWeight={"semibold"} color={textColor} mb={2}>
                {label}
              </Text>
              <DateInput
                filterKey={filterKey}
                updateFilter={updateFilter}
                defaultValue={defaultValue}
              />
            </Card>
          </Flex>
        );

      case "dateRange":
        return (
          <Flex>
            <>
              {/*
                not implemented yet
            */}
              <DateRangeInput />
            </>
          </Flex>
        );

      default:
        return (
          <Flex>
            <Card
              flexDirection="column"
              px="16px"
              overflowX={{ sm: "scroll", lg: "scroll" }}
              borderColor={borderColor}
            >
              <Text fontWeight={"semibold"} color={textColor} mb={4}>
                {label}
              </Text>
              <TextInput
                filterKey={filterKey}
                label={label}
                updateFilter={updateFilter}
              />
            </Card>
          </Flex>
        );
    }
  }, [
    type,
    borderColor,
    textColor,
    label,
    filterKey,
    options,
    updateFilter,
    defaultValue,
  ]);

  return <>{renderFilterItem}</>;
}

export default Filter;
